import tw, { styled } from 'twin.macro';

export const Container = styled.section`
  ${tw`container`}
  ${tw`container-stack-context`}
  ${tw`px-2 lg:px-0`}
  ${tw`grid grid-cols-12`}
`;

export const Wrapper = styled.div<{
  columns: Queries.kontent_item_single_media_elements_width_enum;
}>`
  ${tw`rounded-lg overflow-hidden`}
  ${({ columns }) => {
    switch (columns) {
      case 'columns_10':
        return tw`col-span-12 lg:col-start-2 lg:col-end-12`;
      case 'columns_12':
        return tw`col-span-12`;
    }
  }}
`;
